export default () => ({
  isLoading: false,
  isEnable2FA: false,
  isClickFromDashboard: false,
  showInvalidCode: false,
  showOTPLogin: false,
  remainingTime: 0,
  isDisableResend: false,
})
